import { takeLatest, call, put } from "redux-saga/effects";
import {
  getSimilarProductsStart,
  getSimilarProductsSuccess,
  getSimilarProductsFailure,
} from "redux/similarProducts";
import fetchSimilarProducts from "../services/similarProducts"; // Adjust the import path as necessary

function* fetchSimilarProductsSaga(
  action: ReturnType<typeof getSimilarProductsStart>
): Generator<any, void, any> {
  try {
    const { sellerId, categoryFilter } = action.payload.filter;
    const responseData = yield call(fetchSimilarProducts, {
      sellerId,
      categoryFilter,
    });
    yield put(getSimilarProductsSuccess(responseData.ResponseBody || []));
  } catch (error: any) {
    yield put(getSimilarProductsFailure(error.message || "Unknown error"));
  }
}

// Watcher saga: watches for getSimilarProductsStart
export default function* similarProductsSaga() {
  yield takeLatest(getSimilarProductsStart.type, fetchSimilarProductsSaga);
}
